module.exports = __webpack_public_path__ + "img/es_get.b99d0f3.png";